module.exports = __webpack_public_path__ + "ecb61dde2979cce368cfd3bf6b1efdcb.MP3";